<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="prof_edit_opt_box modal_cont" id="prof_change_pin_modal">
        <img :src="closeIconSrc" class="btn_close">
          <h1>{{ getTranslations.home_modals_change_login_pin_text }}</h1>
          <form class="edit_prof_input">
            <div :class="['form-group', !hasErrors ? '' : 'has-warning' ]">
              <input type="password"
                     class="form-group__textfield phone_input"
                     @keyup="checkPasswordOld"
                     v-model="passwordOld"
                     :placeholder="getTranslations.home_modals_change_login_pin_enter_current" />
              <div  class="failed_sent_text"
                    v-show="hasErrors">
                {{ getMessage(result) }}
              </div>
              <input type="password"
                     @keyup="checkPassword"
                     v-model="passwordNew"
                     class="form-group__textfield phone_input"
                     :placeholder="getTranslations.home_modals_change_login_pin_create_new" />
              <input type="password"
                     @keyup="checkConfirmation"
                     v-model="confirmPassword"
                     class="form-group__textfield phone_input"
                     :placeholder="getTranslations.home_modals_change_login_pin_confirm" />
              <a style="cursor: pointer"
                 @click.prevent="goToForgot()"
                 class="forgot_pin">
                {{ getTranslations.home_modals_change_login_pin_forgot }}
              </a>
              <span class="failed_sent_text"
                    v-if="hasErrors">
               {{ getMessage(message) }}
              </span>
            </div>
            <button type="submit"
                   @click.prevent="changePin()"
                    :class="['ti_btn--main', canProceed() ? '' : 'deactivated']">{{ getTranslations.home_modals_change_login_pin_update }}</button>
          </form>
          <div  class="success_update"
             v-show="!hasErrors">
            {{ getMessage(result) }}
          </div>
    </div></div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'change-login-pin',
  mixins: [SkinMixin],
  data() {
    return {
      hasErrors: false,
      result: '',
      passwordOld: '',
      passwordNew: '',
      confirmPassword: '',
      validPasswordRegex: /^[0-9]{0,8}$/,
    };
  },
  created() {
    this.showModal();
  },
  methods: {
    ...mapActions('profile', [
      'logoutUserFromAuthorizedPages',
    ]),
    goToForgot() {
      this.$router.push('/home/forgotPassword1');
    },
    canProceed() {
      return this.passwordOld && !this.hasErrors && this.passwordNew && this.confirmPassword;
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /*eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          // Maximum exceeded
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    changePin() {
      if (!this.canProceed()) {
        if (!this.message) this.message = 'home_profile_profile_edit_msg_warning_invalid_password';
        this.hasErrors = true;
      } else {
        this.message = '';
        this.$axios({
          url: 'api/changePassword',
          method: 'POST',
          headers: {
            Authorization: this.jwtInVuex,
          },
          data: {
            passwordOld: this.passwordOld,
            password: this.confirmPassword,
          },
        }).then((response) => {
          this.message = '';
          this.result = '';
          this.hasErrors = false;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            this.result = 'home_profile_profile_edit_password_updated';
          } else if (response.data.responseEnum === 'SERVER_ERROR') {
            this.hasErrors = true;
            this.result = 'home_profile_profile_edit_server_unvailable';
          } else {
            this.result = 'home_profile_profile_edit_msg_warning_invalid_password';
            this.hasErrors = true;
          }
        }).catch((error) => {
          this.logoutUserFromAuthorizedPages();
          // eslint-disable-next-line
          console.log(`Invoking changePassword failed with the following error: ${error}`);
        });
      }
    },
    checkConfirmation(evt) {
      if (this.confirmPassword) {
        this.result = '';
        const min = 4;
        const max = this.maximumDigitsPinLength;
        const validPass = this.confirmPassword.match(this.validPasswordRegex);
        this.hasErrors = false;
        this.message = '';
        if (this.confirmPassword.length < min) {
          this.hasErrors = true;
        } else if (this.confirmPassword.length > max) {
          this.confirmPassword = this.checkMaxChar(this.confirmPassword, max, evt);
          this.hasErrors = true;
          this.checkConfirmation();
        } else if (validPass !== null) {
          if (this.confirmPassword.length > max) {
            this.confirmPassword = this.checkMaxChar(this.confirmPassword, max, evt);
            this.hasErrors = true;
            this.checkConfirmation();
          }
          if (this.confirmPassword === '' || (this.confirmPassword === this.passwordNew)) {
            this.hasErrors = false;
          } else {
            this.message = 'home_profile_profile_edit_msg_warning_entered_passwords_not_match';
            this.hasErrors = true;
          }
        } else if (validPass === null) {
          this.hasErrors = true;
          this.message = 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_';
        }
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkPasswordOld() {
      if (this.passwordOld) {
        const min = 4;
        const max = 12;
        this.hasErrors = false;
        this.message = '';
        this.result = '';
        if (this.passwordOld.length < min || this.passwordOld.length > max) {
          this.message = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrors = true;
        }
      }
    },
    checkPassword(evt) {
      if (this.passwordNew) {
        const min = 4;
        const max = this.maximumDigitsPinLength;
        const validPass = this.passwordNew.match(this.validPasswordRegex);
        this.message = '';
        this.hasErrors = false;
        if (this.passwordNew.length < min) {
          this.message = 'home_profile_profile_edit_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrors = true;
        } else if (this.passwordNew.length > max) {
          this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
          this.hasErrors = true;
          this.checkPassword();
        } else if (validPass !== null) {
          if (this.passwordNew.length > max) {
            this.passwordNew = this.checkMaxChar(this.passwordNew, max, evt);
            this.hasErrors = true;
            this.checkPassword();
          }
          if (this.confirmPassword === '' || (this.confirmPassword === this.passwordNew)) {
            this.hasErrors = false;
          } else {
            this.message = 'home_profile_profile_edit_msg_warning_entered_passwords_not_match';
            this.hasErrors = true;
          }
        } else if (validPass === null) {
          this.hasErrors = true;
          this.message = 'home_profile_profile_edit_msg_password_cannot_contain_any_other_symbols_except_from_';
        }
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.prof_edit_opt_box,.overlay').fadeIn(200);
        // show/hide modal
        $('.btn_close, .overlay').click(function () {
          vm.$emit('close');
          $('#changeLoginPin').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    ...mapState('common', [
      'userDetails',
      'maximumDigitsPinLength',
    ]),
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ChangeLoginPin.vue